<template>
  <div class="signup scene flex-r">
    <div class="section size-10" />

    <div class="size-80">
      <div
        class="signup-form-bg shadow-large"
        style="padding:8% 2%; margin-bottom:-10%;"
      >
        <TheHeader />

        <div class="signup-plans flex-r flex-algn-t">
          <template v-for="(plan, index) in plans">
            <div
              v-if="index > 0"
              class="section size-2"
            />

            <PlanItem
              :key="plan.title"
              :plan="plan"
              @selectPlan="selectPlan"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
import TheHeader from './TheHeader';
import PlanItem from './PlanItem';

export default {
  name: 'SelectPlanPanel',
  components: {
    PlanItem,
    TheHeader
  },
  data() {
    return {
      plans: [
        {
          id: 1,
          title: 'Старт 🚀',
          description: 'Акция на год до 1 января 2020, после 9.99 рублей в месяц',
          cost: 30,
          period: 'В месяц',
          href: '/pricing#start',
          features: [
            {
              title: 'POS',
              additionalInformation: '1 терминал',
              href: '/platform#pos'
            },
            {
              title: 'Меню',
              additionalInformation: 'Офлайн',
              href: '/platform#menu'
            },
            {
              title: 'Статистика',
              additionalInformation: 'Ограниченная',
              href: '/platform#pos'
            }
          ],
          customizationBlocks: [
            {
              title: 'План поддержки:',
              tickets: [
                {
                  title: 'Только ПО',
                  cost: 0,
                  isSelected: true
                },
                {
                  title: 'Онлайн-поддержка',
                  cost: 19.99,
                  isSelected: false
                }
              ]
            }
          ]
        },
        {
          id: 2,
          title: 'Базовый — Офлайн   🌿',
          description: 'Кафе, Бары, Рестораны, Пиццерии, Фудкорты, Кебабные, Take&amp;Away и др.',
          cost: 59.99,
          period: 'В месяц',
          href: '/pricing#basic-offline',
          features: [
            {
              title: 'POS',
              additionalInformation: '1 терминал',
              href: '/platform#pos'
            },
            {
              title: 'Меню',
              additionalInformation: 'Офлайн',
              href: '/platform#pos'
            },
            {
              title: 'Кухня',
              additionalInformation: '2 рабочих места',
              href: '/platform#pos'
            },
            {
              title: 'Экран выдачи',
              additionalInformation: '2 экрана',
              href: '/platform#pos'
            },
            {
              title: 'Склад',
              additionalInformation: '1 склад',
              href: '/platform#pos'
            },
            {
              title: 'Статистика',
              additionalInformation: 'Ограниченная',
              href: '/platform#pos'
            }
          ],
          customizationBlocks: [
            {
              title: 'План поддержки:',
              tickets: [
                {
                  title: 'Онлайн-поддержка',
                  cost: 0,
                  isSelected: true
                },
                {
                  title: 'Расширенная поддержка',
                  cost: 239.99,
                  isDisabled: true
                },
                {
                  title: 'Полное сопровождение',
                  cost: 639.99,
                  isDisabled: true
                }
              ]
            }
          ]
        },
        {
          id: 3,
          title: 'Базовый — Онлайн 💰💰💰',
          description: 'Кафе, Бары, Рестораны, Пиццерии, Фудкорты, Кебабные, Take&amp;Away и др.',
          cost: 119.99,
          period: 'В месяц',
          href: '/pricing#basic-online',
          features: [
            {
              title: 'POS',
              additionalInformation: '1 терминал',
              href: '/platform#pos'
            },
            {
              title: 'Меню',
              additionalInformation: 'Онлайн',
              href: '/platform#pos'
            },
            {
              title: 'Кухня',
              additionalInformation: '2 рабочих места',
              href: '/platform#pos'
            },
            {
              title: 'Экран выдачи',
              additionalInformation: '2 экрана',
              href: '/platform#pos'
            },
            {
              title: 'Склад',
              additionalInformation: '1 склад',
              href: '/platform#pos'
            },
            {
              title: 'Статистика',
              additionalInformation: 'Полная',
              href: '/platform#pos'
            },
            {
              title: 'Встраиваемый виджет',
              additionalInformation: '✔️',
              href: '/platform#pos'
            },
            {
              title: 'Онлайн-заказ и оплата',
              additionalInformation: '✔️',
              href: '/platform#pos'
            },
            {
              title: 'База клиентов',
              additionalInformation: '✔️',
              href: '/platform#pos'
            }
          ],
          customizationBlocks: [
            {
              title: 'Пакет SMS-сообщений на месяц:',
              tickets: [
                {
                  title: '1.000 SMS',
                  cost: 16.99,
                  isSelected: true
                },
                {
                  title: '3.000 SMS',
                  cost: 49.99,
                  isSelected: false
                },
                {
                  title: '5.000 SMS',
                  cost: 79.99,
                  isSelected: false
                },
                {
                  title: '10.000 SMS',
                  cost: 155.50,
                  isSelected: false
                }
              ]
            },
            {
              title: 'План поддержки:',
              tickets: [
                {
                  title: 'Онлайн-поддержка',
                  cost: 0,
                  isSelected: true
                },
                {
                  title: 'Расширенная поддержка',
                  cost: 239.99,
                  isDisabled: true
                },
                {
                  title: 'Полное сопровождение',
                  cost: 639.99,
                  isDisabled: true
                }
              ]
            }
          ]
        },
        {
          id: 4,
          title: 'Про+ 💪💪💪',
          description: 'Кафе, Бары, Рестораны, Пиццерии, Фудкорты, Кебабные, Take&amp;Away и др.',
          cost: 379.99,
          period: 'В месяц',
          href: '/pricing#pro',
          features: [
            {
              title: 'POS',
              additionalInformation: '1 терминал',
              href: '/platform#pos'
            },
            {
              title: 'Меню',
              additionalInformation: 'Онлайн',
              href: '/platform#pos'
            },
            {
              title: 'Кухня',
              additionalInformation: '2 рабочих места',
              href: '/platform#pos'
            },
            {
              title: 'Экран выдачи',
              additionalInformation: '2 экрана',
              href: '/platform#pos'
            },
            {
              title: 'Склад',
              additionalInformation: '1 склад',
              href: '/platform#pos'
            },
            {
              title: 'Статистика',
              additionalInformation: 'Полная',
              href: '/platform#pos'
            },
            {
              title: 'Встраиваемый виджет',
              additionalInformation: '✔️',
              href: '/platform#pos'
            },
            {
              title: 'Онлайн-заказ и оплата',
              additionalInformation: '✔️',
              href: '/platform#pos'
            },
            {
              title: 'База клиентов',
              additionalInformation: '✔️',
              href: '/platform#clients'
            },
            {
              title: 'Хот-спот',
              additionalInformation: '✔️',
              href: '/platform#wifi'
            },
            {
              title: 'API',
              additionalInformation: '✔️',
              href: '/platform#API'
            }
          ],
          customizationBlocks: [
            {
              title: 'Пакет SMS-сообщений на месяц:',
              tickets: [
                {
                  title: '10.000 SMS',
                  cost: 139.99,
                  isSelected: true
                },
                {
                  title: '30.000 SMS',
                  cost: 406.99,
                  isSelected: false
                },
                {
                  title: '50.000 SMS',
                  cost: 639.99,
                  isSelected: false
                },
                {
                  title: '100.000 SMS',
                  cost: 1255.99,
                  isSelected: false
                }
              ]
            },
            {
              title: 'План поддержки:',
              tickets: [
                {
                  title: 'Онлайн-поддержка',
                  cost: 0,
                  isSelected: true
                },
                {
                  title: 'Расширенная поддержка',
                  cost: 239.99,
                  isDisabled: true
                },
                {
                  title: 'Полное сопровождение',
                  cost: 639.99,
                  isDisabled: true
                }
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    selectPlan(plan) {
      switch (plan.id) {
        case 1: {
          if (plan.customizationBlocks[0].tickets[0].isSelected) {
            this.$emit('selectPlan', 1);
          } else {
            this.$emit('selectPlan', 2);
          }

          break;
        }

        case 2: {
          this.$emit('selectPlan', 3);
          break;
        }

        case 3: {
          if (plan.customizationBlocks[0].tickets[0].isSelected) {
            this.$emit('selectPlan', 4);
          } else if (plan.customizationBlocks[0].tickets[1].isSelected) {
            this.$emit('selectPlan', 5);
          } else if (plan.customizationBlocks[0].tickets[2].isSelected) {
            this.$emit('selectPlan', 6);
          } else {
            this.$emit('selectPlan', 7);
          }

          break;
        }

        case 4: {
          if (plan.customizationBlocks[0].tickets[0].isSelected) {
            this.$emit('selectPlan', 8);
          } else if (plan.customizationBlocks[0].tickets[1].isSelected) {
            this.$emit('selectPlan', 9);
          } else if (plan.customizationBlocks[0].tickets[2].isSelected) {
            this.$emit('selectPlan', 10);
          } else {
            this.$emit('selectPlan', 11);
          }

          break;
        }
      }
    }
  }
}
</script>
